import { FileText } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function QuotesPage() {
  return (
    <PhaseStubPage
      title="Quotes"
      phase={4}
      modules={[
        'Quote authoring with customer-tier pricing pull',
        'PDF generation + customer email link',
        'Accept → auto-create sales order',
        'Expiry handling and follow-up reminders',
      ]}
      icon={FileText}
    />
  );
}
